// import React, { useState, useRef, useEffect } from "react";
// import {
//   Box,
//   useTheme,
//   Button,
//   Modal,
//   TextField,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   InputLabel,
//   Select,
//   MenuItem,
//   Typography,
//   CircularProgress,
//   IconButton,
// } from "@mui/material";

// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";

// // import { styled } from '@mui/material/styles';

// import { DataGrid, GridApi } from "@mui/x-data-grid";

// import {
//   useGetCouponsQuery,
//   useCreateCouponsMutation,
//   useUpdateCouponsMutation,
//   useDeleteCouponsMutation,
// } from "state/api";
// import { Header } from "components";

// const Coupons = () => {
//   const { data, isLoading, refetch } = useGetCouponsQuery();

//   console.log("Coupons data:", data);

//   const [createCoupons] = useCreateCouponsMutation();
//   const [updateCoupons] = useUpdateCouponsMutation();
//   const [deleteCoupons] = useDeleteCouponsMutation();

//   const theme = useTheme();

//   const gridApiRef = useRef(null);

//   useEffect(() => {
//     // Access grid API when it's ready
//     if (gridApiRef.current) {
//       const api = gridApiRef.current;
//       // Perform any actions needed with the grid API here
//       // For example, you could set initial selected rows:
//       api.setSelectedRows([0]);
//     }
//   }, [gridApiRef]);

//   // data columns
//   const columns = [
//     // {
//     //   field: "_id",
//     //   headerName: "ID",
//     //   flex: 1,
//     // },
//     {
//       field: "name",
//       headerName: "Coupons Title",
//       flex: 1,
//       // editable: true,
//     },
//     // {
//     //   field: "description",
//     //   headerName: "Coupons Description",
//     //   flex: 1,
//     //   // editable: true,
//     // },

//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 0.5,
//       renderCell: (params) => {
//         const { _id } = params.row;
//         console.log("Row data:", _id);
//         return (
//           <div>
//             <IconButton
//               color="primary"
//               aria-label="edit"
//               onClick={() => handleOpenEdit(_id)}
//             >
//               <EditIcon sx={{ color: "white" }} />
//             </IconButton>
//             <IconButton
//               color="error"
//               aria-label="delete"
//               onClick={() => handleDeleteCoupons(_id)}
//             >
//               <DeleteIcon />
//             </IconButton>
//           </div>
//         );
//       },
//     },
//   ];

//   const [open, setOpen] = useState(false);
//   const [name, setname] = useState("");
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const [user, setUser] = useState(null);
//   const [nameError, setnameError] = useState(null);
//   const [CouponsCategory, setCouponsCategory] = useState("Coupons"); // Initial selection
//   const [CouponsCategoryError, setCouponsCategoryError] = useState(null);
//   const [selectedFileError, setSelectedFileError] = useState(null);
//   const [descriptionError, setdescriptionError] = useState(null);
//   const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator
//   const [selectedEditRowData, setSelectedEditRowData] = useState(null); // Add this state to store the selected row's data

//   const [CouponsEditError, setCouponsEditError] = useState(null);

//   // New state to track the modified fields
//   const [modifiedFields, setModifiedFields] = useState({});

//   const handlenameChange = (event) => {
//     setname(event.target.value);
//     // Update the modified fields
//     // setModifiedFields({ ...modifiedFields, name: selectedEditRowData.name });
//     setModifiedFields({ ...modifiedFields, name: event.target.value });

//     setnameError(
//       event.target.value ? null : "Enter Coupons name"
//     );
//   };

//   const handleCategoryChange = (event) => {
//     setCouponsCategory(event.target.value);
//     // Update the modified fields
//     // setModifiedFields({ ...modifiedFields, CouponsCategory: selectedEditRowData.CouponsCategory });
//     setModifiedFields({
//       ...modifiedFields,
//       CouponsCategory: event.target.value,
//     });

//     setCouponsCategoryError(
//       event.target.value ? null : "Please select a category"
//     );
//   };

//   const handleSubmit = async () => {
//     console.log("working");
//     // ... other logic

//     if (!name) {
//       setnameError("Enter Coupons name");
//       return;
//     }

//     // if (!description) {
//     //   setdescriptionError("Enter Coupons description");
//     //   return;
//     // }

//     setIsLoadingSubmit(true); // Start loading before asynchronous operations
//     const updateData = {
//       name: name,
//     };
//     console.log("206 working");
//     await createCoupons(updateData);

//     setIsLoadingSubmit(false); // Stop loading after data is created

//     setOpen(false); // Close the modal after successful submission

//     refetch();
//   };

//   const handleOpenEdit = (id) => {
//     const selectedRow = data.data.find((row) => row._id === id);

//     if (selectedRow) {
//       setname(selectedRow.name || "");
//       setSelectedEditRowData(selectedRow);

//       // Set the modified fields to an empty object initially
//       setModifiedFields({});

//       setOpen(true);
//     }
//   };

//   const handleEditSubmit = async () => {
//     // Only send the modified fields to the API
//     if (Object.keys(modifiedFields).length > 0) {
//       setIsLoadingSubmit(true); // Start loading before asynchronous operations

//       const { selectedFile, ...rest } = modifiedFields;

//       const editedCouponsData = {
//         id: selectedEditRowData._id,
//         ...modifiedFields,
//       };

//       await updateCoupons(editedCouponsData);
//       setModifiedFields({});
//       setSelectedEditRowData(null);

//       setIsLoadingSubmit(false);

//       setOpen(false);
//       refetch();
//     } else {
//       setCouponsEditError("Edit a value first");
//       return;
//     }

//     // Rest of the code...
//   };

//   const handleDeleteCoupons = async (catId) => {
//     console.log("Delete ID:", catId);

//     if (
//       window.confirm(
//         "Are you sure you want to delete this Coupons?"
//       )
//     ) {
//       try {
//         // await deleteCoupons.mutateAsync(id);
//         // await deleteCoupons(id);
//         await deleteCoupons({ id: catId }).unwrap();
//         refetch(); // Reload to reflect changes in the UI
//       } catch (error) {
//         console.error("Error deleting Coupons:", error);
//       }
//     }
//   };

//   return (
//     <Box m="1.5rem 2.5rem">
//       {/* Header */}
//       {/* <Header title="Coupons" subtitle="List of Coupons" /> */}
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Header
//           title="Coupons"
//           subtitle="List of Coupons"
//         />
//         <Button
//           variant="contained"
//           color="primary"
//           size="medium"
//           onClick={handleOpen}
//         >
//           {"Add Coupons"}
//         </Button>
//       </Box>

//       {/* Content */}
//       <Box
//         mt="40px"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: theme.palette.background.alt,
//             color: theme.palette.secondary[100],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: theme.palette.primary.light,
//           },
//           "& .MuiDataGrid-footerContainer": {
//             backgroundColor: theme.palette.primary.light,
//             color: theme.palette.secondary[100],
//             borderTop: "none",
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
//             color: `${theme.palette.secondary[200]} !important`,
//           },
//         }}
//       >
//         {/* Grid table */}
//         <DataGrid
//           loading={isLoading || !data.data}
//           getRowId={(row) => row._id}
//           rows={data !== undefined ? data.data : []}
//           columns={columns}
//         />
//       </Box>

//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box
//           sx={{
//             minWidth: 500, // Adjust the minimum width for your modal
//             p: 4, // Add padding inside the modal
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             bgcolor: "background.paper", // Set white background
//             borderRadius: 2, // Add rounded borders (adjust the value)
//             boxShadow: 24,
//           }}
//         >
//           <DialogContent>
//             {/* Error messages */}
//             {nameError && (
//               <Typography variant="caption" color="error">
//                 {nameError}
//               </Typography>
//             )}
//             {selectedFileError && (
//               <Typography variant="caption" color="error">
//                 {selectedFileError}
//               </Typography>
//             )}
//             {CouponsEditError && (
//               <Typography variant="caption" color="error">
//                 {CouponsEditError}
//               </Typography>
//             )}

//             <DialogContentText>
//               {!selectedEditRowData
//                 ? "Add a new Coupons"
//                 : "Edit Coupons"}
//             </DialogContentText>
//             <TextField
//               label="Coupons Name"
//               value={name}
//               onChange={handlenameChange}
//               error={!!nameError} // Set error prop based on error state
//               helperText={nameError} // Set helper text for error display
//               fullWidth
//               margin="normal"
//             />
//             <br />

//             <br />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleClose} color="primary">
//               Cancel
//             </Button>
//             {/* <Button onClick={handleSubmit} color="primary">
//               Save
//             </Button> */}

//             <Button
//               onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit}
//               color="primary"
//               disabled={isLoadingSubmit}
//             >
//               {isLoadingSubmit ? (
//                 <CircularProgress
//                   size="medium"
//                   style={{ width: 20, height: 20, color: "white" }}
//                 />
//               ) : (
//                 "Save"
//               )}
//               {/* Save */}
//             </Button>
//           </DialogActions>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default Coupons;


import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  useTheme,
  Button,
  Modal,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Typography,
  CircularProgress,
  IconButton,
  Chip,
  FormHelperText,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Tooltip,} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import { Toaster } from "react-hot-toast";
import {
  useGetCouponsQuery,
  useCreateCouponsMutation,
  useUpdateCouponsMutation,
  useDeleteCouponsMutation,
} from "state/api";
import { Header } from "components";

const Coupons = () => {
  const { data, isLoading, refetch } = useGetCouponsQuery();

  console.log("Coupons data:", data);

  const [createCoupons] = useCreateCouponsMutation();
  const [updateCoupons] = useUpdateCouponsMutation();
  const [deleteCoupons] = useDeleteCouponsMutation();

  const theme = useTheme();
  const gridApiRef = useRef(null);

  // Form state
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [type, setType] = useState("basic");
  const [planExpiry, setPlanExpiry] = useState("3M");
  const [durationDays, setDurationDays] = useState(30);
  const [maxUsage, setMaxUsage] = useState(1);
  const [maxUsers, setMaxUsers] = useState(1);
  const [isActive, setIsActive] = useState(true);

  // Error states
  const [codeError, setCodeError] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [planExpiryError, setPlanExpiryError] = useState(null);
  const [durationDaysError, setDurationDaysError] = useState(null);
  const [maxUsageError, setMaxUsageError] = useState(null);
  const [maxUsersError, setMaxUsersError] = useState(null);
  const [generalError, setGeneralError] = useState(null);
  
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [selectedEditRowData, setSelectedEditRowData] = useState(null);
  const [modifiedFields, setModifiedFields] = useState({});

  useEffect(() => {
    if (gridApiRef.current) {
      const api = gridApiRef.current;
      api.setSelectedRows([0]);
    }
  }, [gridApiRef]);

  // Data columns
  const columns = [
{
    field: "code",
    headerName: "Coupon Code",
    flex: 1,
    renderCell: (params) => {
      const handleCopy = () => {
        navigator.clipboard.writeText(params.value);
         toast.success("Code copied!");
      };

      return (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span>{params.value}</span>
          <Tooltip title="Copy code">
            <IconButton
              size="small"
              onClick={handleCopy}
              sx={{ ml: 0.5 }}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    },
  },
    {
      field: "type",
      headerName: "Type",
      flex: 0.7,
      renderCell: (params) => (
        <Chip
          label={params.value.toUpperCase()}
          color={params.value === "premium" ? "secondary" : "default"}
          size="small"
        />
      ),
    },
    {
      field: "planExpiry",
      headerName: "Plan Expiry",
      flex: 0.7,
    },
    // {
    //   field: "durationDays",
    //   headerName: "Duration (Days)",
    //   flex: 0.8,
    // },
    // {
    //   field: "maxUsage",
    //   headerName: "Max Usage",
    //   flex: 0.7,
    // },
    {
      field: "maxUsers",
      headerName: "Max Users",
      flex: 0.7,
    },
    {
      field: "usedBy",
      headerName: "Used Count",
      flex: 0.7,
      renderCell: (params) => params.value?.length || 0,
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 0.7,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "error"}
          size="small"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.7,
      renderCell: (params) => {
        const { _id } = params.row;
        return (
          <div>
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handleOpenEdit(_id)}
            >
              <EditIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              color="error"
              aria-label="delete"
              onClick={() => handleDeleteCoupon(_id)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  // Handlers
  const handleOpen = () => {
    resetForm();
    setOpen(true);
  };

  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  const resetForm = () => {
    setCode("");
    setType("basic");
    setPlanExpiry("3M");
    setDurationDays(30);
    setMaxUsage(1);
    setMaxUsers(1);
    setIsActive(true);
    setCodeError(null);
    setTypeError(null);
    setPlanExpiryError(null);
    setDurationDaysError(null);
    setMaxUsageError(null);
    setMaxUsersError(null);
    setGeneralError(null);
    setSelectedEditRowData(null);
    setModifiedFields({});
  };

  const handleCodeChange = (event) => {
    const value = event.target.value.trim().toUpperCase();
    setCode(value);
    setModifiedFields({ ...modifiedFields, code: value });
    setCodeError(value ? null : "Coupon code is required");
  };

  const handleTypeChange = (event) => {
    const value = event.target.value;
    setType(value);
    setModifiedFields({ ...modifiedFields, type: value });
    setTypeError(null);
  };

  const handlePlanExpiryChange = (event) => {
    const value = event.target.value;
    setPlanExpiry(value);
    setModifiedFields({ ...modifiedFields, planExpiry: value });
    setPlanExpiryError(null);
  };

  const handleDurationDaysChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    setDurationDays(value);
    setModifiedFields({ ...modifiedFields, durationDays: value });
    setDurationDaysError(value > 0 ? null : "Duration must be greater than 0");
  };

  const handleMaxUsageChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    setMaxUsage(value);
    setModifiedFields({ ...modifiedFields, maxUsage: value });
    setMaxUsageError(value > 0 ? null : "Max usage must be greater than 0");
  };

  const handleMaxUsersChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    setMaxUsers(value);
    setModifiedFields({ ...modifiedFields, maxUsers: value });
    setMaxUsersError(value > 0 ? null : "Max users must be greater than 0");
  };

  const handleIsActiveChange = (event) => {
    const value = event.target.checked;
    setIsActive(value);
    setModifiedFields({ ...modifiedFields, isActive: value });
  };

  const validateForm = () => {
    let isValid = true;

    if (!code) {
      setCodeError("Coupon code is required");
      isValid = false;
    }

    // if (durationDays <= 0) {
    //   setDurationDaysError("Duration must be greater than 0");
    //   isValid = false;
    // }

    // if (maxUsage <= 0) {
    //   setMaxUsageError("Max usage must be greater than 0");
    //   isValid = false;
    // }

    if (maxUsers <= 0) {
      setMaxUsersError("Max users must be greater than 0");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    setGeneralError(null);

    if (!validateForm()) {
      return;
    }

    try {
      setIsLoadingSubmit(true);
      
      const couponData = {
        code,
        type,
        planExpiry,
        durationDays,
        maxUsage,
        maxUsers,
        isActive,
      };

      const result = await createCoupons(couponData).unwrap();
      
      console.log("Coupon created:", result);
      setOpen(false);
      refetch();
      resetForm();
    } catch (error) {
      console.error("Error creating coupon:", error);
      setGeneralError(
        error?.data?.message || 
        error?.message || 
        "Failed to create coupon. Please try again."
      );
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const handleOpenEdit = (id) => {
    const selectedRow = data?.data?.find((row) => row._id === id);

    if (selectedRow) {
      setCode(selectedRow.code || "");
      setType(selectedRow.type || "basic");
      setPlanExpiry(selectedRow.planExpiry || "3M");
      setDurationDays(selectedRow.durationDays || 30);
      setMaxUsage(selectedRow.maxUsage || 1);
      setMaxUsers(selectedRow.maxUsers || 1);
      setIsActive(selectedRow.isActive !== undefined ? selectedRow.isActive : true);
      setSelectedEditRowData(selectedRow);
      setModifiedFields({});
      setOpen(true);
    }
  };

  const handleEditSubmit = async () => {
    setGeneralError(null);

    if (Object.keys(modifiedFields).length === 0) {
      setGeneralError("Please modify at least one field");
      return;
    }

    if (!validateForm()) {
      return;
    }

    try {
      setIsLoadingSubmit(true);

      const editedCouponData = {
        id: selectedEditRowData._id,
        ...modifiedFields,
      };

      const result = await updateCoupons(editedCouponData).unwrap();
      
      console.log("Coupon updated:", result);
      setOpen(false);
      refetch();
      resetForm();
    } catch (error) {
      console.error("Error updating coupon:", error);
      setGeneralError(
        error?.data?.message || 
        error?.message || 
        "Failed to update coupon. Please try again."
      );
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const handleDeleteCoupon = async (id) => {
    if (!window.confirm("Are you sure you want to delete this coupon?")) {
      return;
    }

    try {
      await deleteCoupons({ id }).unwrap();
      refetch();
    } catch (error) {
      console.error("Error deleting coupon:", error);
      alert(
        error?.data?.message || 
        error?.message || 
        "Failed to delete coupon. Please try again."
      );
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Coupons" subtitle="Manage coupon codes" />
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={handleOpen}
        >
          Add Coupon
        </Button>
      </Box>

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        <DataGrid
          loading={isLoading || !data?.data}
          getRowId={(row) => row._id}
          rows={data?.data || []}
          columns={columns}
        />
      </Box>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            minWidth: 600,
            maxWidth: 700,
            p: 4,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <DialogContent>
            <DialogContentText sx={{ mb: 3 }}>
              {!selectedEditRowData ? "Add a new coupon" : "Edit coupon"}
            </DialogContentText>

            {/* General Error */}
            {generalError && (
              <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                {generalError}
              </Typography>
            )}

            {/* Coupon Code */}
            <TextField
              label="Coupon Code"
              value={code}
              onChange={handleCodeChange}
              error={!!codeError}
              helperText={codeError || "e.g., FREEMONTH, SUMMER2024"}
              fullWidth
              margin="normal"
              required
            />

            {/* Type */}
            <FormControl fullWidth margin="normal" error={!!typeError}>
              <InputLabel>Type</InputLabel>
              <Select value={type} onChange={handleTypeChange} label="Type">
                <MenuItem value="basic">Basic</MenuItem>
                <MenuItem value="premium">Premium</MenuItem>
              </Select>
              {typeError && <FormHelperText>{typeError}</FormHelperText>}
            </FormControl>

            {/* Plan Expiry */}
            <FormControl fullWidth margin="normal" error={!!planExpiryError}>
              <InputLabel>Plan Expiry</InputLabel>
              <Select
                value={planExpiry}
                onChange={handlePlanExpiryChange}
                label="Plan Expiry"
              >
                <MenuItem value="3M">3 Months</MenuItem>
                <MenuItem value="6M">6 Months</MenuItem>
                <MenuItem value="1Y">1 Year</MenuItem>
                <MenuItem value="UN">Unlimited</MenuItem>
              </Select>
              {planExpiryError && (
                <FormHelperText>{planExpiryError}</FormHelperText>
              )}
            </FormControl>

            {/* Duration Days
            <TextField
              label="Duration (Days)"
              type="number"
              value={durationDays}
              onChange={handleDurationDaysChange}
              error={!!durationDaysError}
              helperText={
                durationDaysError || "How long the coupon is valid after redemption"
              }
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 1 }}
            /> */}

            {/* Max Usage */}
            {/* <TextField
              label="Max Usage"
              type="number"
              value={maxUsage}
              onChange={handleMaxUsageChange}
              error={!!maxUsageError}
              helperText={maxUsageError || "Total number of times coupon can be used"}
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 1 }}
            /> */}

            {/* Max Users */}
            <TextField
              label="Max Users"
              type="number"
              value={maxUsers}
              onChange={handleMaxUsersChange}
              error={!!maxUsersError}
              helperText={maxUsersError || "Maximum number of users who can use this coupon"}
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 1 }}
            />

            {/* Is Active */}
            <FormControlLabel
              control={
                <Switch
                  checked={isActive}
                  onChange={handleIsActiveChange}
                  color="primary"
                />
              }
              label="Active"
              sx={{ mt: 2 }}
            />

            {/* Show usage info when editing */}
            {selectedEditRowData && selectedEditRowData.usedBy && (
              <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: "block" }}>
                Currently used by {selectedEditRowData.usedBy.length} user(s)
              </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="inherit">
              Cancel
            </Button>
            <Button
              onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit}
              color="primary"
              variant="contained"
              disabled={isLoadingSubmit}
            >
              {isLoadingSubmit ? (
                <CircularProgress
                  size={20}
                  style={{ color: "white" }}
                />
              ) : (
                "Save"
              )}
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </Box>
  );
};

export default Coupons;